import { Box, Typography } from '@mui/material'
import { FC } from 'react'

interface MessageProps {
  message: string
  isError?: boolean
  isSuccess?: boolean
}
export const Message: FC<MessageProps> = ({ message, isError, isSuccess }) => {
  return (
    <Box
      sx={{
        // width: { xs: '90%', sm: '70%', md: '50%', lg: '35%' },
        width: { lg: '600px', md: '600px', sm: '600px', xs: '90%' },
        height: 80,
        padding: ' 1rem 1rem 1rem 1rem',
        position: 'fixed',
        zIndex: 4,
        bottom: 100,
        backgroundColor: isSuccess
          ? 'success.main'
          : isError
          ? '#FF5252'
          : 'transparent',
        borderRadius: '4px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
      }}
    >
      <Typography
        sx={{ ml: 3, fontSize: '16px', fontWeight: '400', color: 'white' }}
      >
        {message}
      </Typography>
    </Box>
  )
}
